module.exports = __webpack_public_path__ + "files/b91d0c9cfeeece180e10cbfd2349ef36.svg";